/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { createContext, useContext } from 'react';
import { EventTrigger } from '../../fragments/types';

function eventTriggerFactory(domElement: HTMLElement, fragmentName?: string): EventTrigger {
  return (name: string, detail?: any): void => {
    domElement.dispatchEvent(new CustomEvent(`${fragmentName}:${name}`, { bubbles: true, cancelable: false, detail }));
  };
}

export const EventSystemContext = createContext<any>(null);
export const EventSystemProvider = React.memo(
  ({
    children,
    fragmentName,
    domElm,
  }: {
    children: React.ReactNode;
    domElm: HTMLElement;
    fragmentName: string;
  }): JSX.Element => {
    if (!fragmentName) {
      throw new Error('Missing `name` attribute on the app-composer');
    }
    const dispatchEvent: EventTrigger = eventTriggerFactory(domElm, fragmentName);

    return <EventSystemContext.Provider value={{ dispatchEvent }}>{children}</EventSystemContext.Provider>;
  },
);
EventSystemProvider.displayName = 'EventSystemProvider';

export const useEventSystem = (): any => useContext(EventSystemContext);
